'use strict';

module.exports = function all() {
  return this.items;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/all.js
// module id = 1208
// module chunks = 2